import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from '@mui/material';
import { createUpdateAccountEntry, getAccountEntries } from './utils';
import ListComponent from './ListComponent';
import ALoader from '../../../common/a-loader';
import AButton from '../../../common/form-fields-mui/AButton';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { successToast } from '../../../common/utils/methods/toasterFunctions/function';
import SearchInput from '../../../masters/onlinePackage/SearchInput';

const AccountEntrySetupDialog = ({
    dialogInfo,
    setDialogInfo
}) => {

    const [accountEntriesList, setAccountEntriesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchInputVal, setSearchInputVal] = useState('');

    const ref = useRef();
    const { isOpen, paymentModeId, paymentModeKey } = dialogInfo;

    const closeDialog = () => setDialogInfo(prev => ({ ...prev, isOpen: false }));

    const fetchAccountEntriesForPaymentMode = async (filterVal = searchInputVal) => {
        try {
            setLoading(true);
            debugger
            const list = await getAccountEntries(paymentModeId, filterVal);
            setAccountEntriesList(list);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }

    const createUpdateHandler = async (rowForm) => {
        try {
            setLoading(true);
            const resp = await createUpdateAccountEntry({ ...rowForm, paymentModeId });
            if (resp?.code === 200) {
                fetchAccountEntriesForPaymentMode();
                successToast("Request completed successfully!!!");
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const searchHandler = (inputVal) => {
        setSearchInputVal(inputVal);
        fetchAccountEntriesForPaymentMode(inputVal);
    }

    useEffect(() => {
        isOpen && fetchAccountEntriesForPaymentMode();
    }, [])

    return (
        <Dialog
            open={!!isOpen}
            fullWidth
            maxWidth="xl"
        >

            <div className='d-flex flex-column p-3'>

                {loading && <ALoader position={"fixed"} />}

                <div className='d-flex justify-content-between align-items-center mb-1'>

                    <h3>Payment Mode : {paymentModeKey}</h3>

                    <div className='d-flex'>

                        <SearchInput
                            inputStyles={{ border: "1px solid #000", width: '15rem', minWidth: '15rem' }}
                            placeholder={"Search by account"}
                            searchInputValueHandler={searchHandler}
                            onCancel={() => searchHandler('')}
                        />

                        <AButton
                            variant='primary_filled'
                            size='xs'
                            onClick={() => ref.current.addNewRow()}
                        >
                            Add new row
                        </AButton>

                        <CrossIcon className='ml-2' onClick={closeDialog} />
                    </div>


                </div>

                <ListComponent
                    rows={accountEntriesList}
                    loading={loading}
                    createUpdateHandler={createUpdateHandler}
                    ref={ref}
                />

            </div>

        </Dialog>
    );
}

export default AccountEntrySetupDialog;